<h2 mat-dialog-title>
    {{ tituloPrincipal() }}

    @if (datosIncidencia) {
        @if (datosIncidencia.estado == 1) {
            @if (rol === "USUARIO") {
                @if (
                    datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 1 && datosIncidencia.estado == 1
                ) {
                    <span style="font-weight: bold; color: brown; text-align: rigth"> (Falta documentación) </span>
                }
                @if (datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 0) {
                    <span style="font-weight: bold; color: rgb(165, 118, 42); text-align: rigth">
                        (Validar documentación)
                    </span>
                }
            }
            @if (rol === "MANAGER") {
                @if (
                    datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 1 && datosIncidencia.estado == 1
                ) {
                    <span style="font-weight: bold; color: rgb(165, 118, 42); text-align: rigth">
                        (Falta documentación)
                    </span>
                }
                @if (datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 0) {
                    <span style="font-weight: bold; color: brown; text-align: rigth"> (Revisar documentación) </span>
                }
            }

            @if (rol === "RRHH") {
                @if (
                    datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 1 && datosIncidencia.estado == 1
                ) {
                    <span style="font-weight: bold; color: rgb(165, 118, 42); text-align: rigth">
                        (Falta documentación)
                    </span>
                }
                @if (datosIncidencia.checkedBoss == 0 && datosIncidencia.needDocument == 0) {
                    <span style="font-weight: bold; color: brown; text-align: rigth"> (Revisar documentación) </span>
                }
            }
        }
    }
</h2>
<mat-dialog-content class="dialog-detalles-ausencia" style="width: 100% !important; overflow-y: auto">
    @if (isLoading) {
        <div class="dialog-detalles-ausencia__loading" fxLayout="row" fxLayoutAlign="center center">
            <mat-spinner diameter="36"></mat-spinner>
        </div>
    }

    @if (!isLoading && loadError) {
        <p class="dialog-detalles-ausencia__error">{{ mensajeErrorCarga() }}</p>
    }

    @if (!isLoading && !loadError && datosIncidencia) {
        <div class="dialog-detalles-ausencia__person" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <div class="dialog-detalles-ausencia__avatar-wrap">
                <img class="dialog-detalles-ausencia__avatar" [src]="getImageUser(datosIncidencia.username)" alt="" />
            </div>
            <div class="dialog-detalles-ausencia__person-name">{{ datosIncidencia.displayName || "—" }}</div>
        </div>

        <section class="dialog-detalles-ausencia__info" [attr.aria-label]="ariaLabelDatosPrincipal()">
            <div class="dialog-detalles-ausencia__row">
                <span class="dialog-detalles-ausencia__label">Estado</span>
                <span
                    class="dialog-detalles-ausencia__value dialog-detalles-ausencia__estado"
                    [class.dialog-detalles-ausencia__estado--pendiente]="datosIncidencia.estado === 0"
                    [class.dialog-detalles-ausencia__estado--aceptado]="datosIncidencia.estado === 1"
                    [class.dialog-detalles-ausencia__estado--cancelado]="datosIncidencia.estado === 2"
                >
                    {{ estadoTexto(datosIncidencia.estado) }}
                </span>
            </div>
            <div class="dialog-detalles-ausencia__row">
                <span class="dialog-detalles-ausencia__label">Tipo</span>
                <span class="dialog-detalles-ausencia__value">{{ datosIncidencia.tipoName || "—" }}</span>
            </div>
            @if (mostrarSubtipo(datosIncidencia)) {
                <div class="dialog-detalles-ausencia__row">
                    <span class="dialog-detalles-ausencia__label">Subtipo</span>
                    <span class="dialog-detalles-ausencia__value">{{ datosIncidencia.subtipoName }}</span>
                </div>
            }
            <div class="dialog-detalles-ausencia__row">
                <span class="dialog-detalles-ausencia__label">Fecha de creación</span>
                <span class="dialog-detalles-ausencia__value">{{ formatDateTime(datosIncidencia.creationDate) }}</span>
            </div>
            <div class="dialog-detalles-ausencia__row">
                <span class="dialog-detalles-ausencia__label">Inicio</span>
                <span class="dialog-detalles-ausencia__value">{{ periodoInicio(datosIncidencia) }}</span>
            </div>
            <div class="dialog-detalles-ausencia__row">
                <span class="dialog-detalles-ausencia__label">Fin</span>
                <span class="dialog-detalles-ausencia__value">{{ periodoFin(datosIncidencia) }}</span>
            </div>
        </section>

        <section class="dialog-detalles-ausencia__motivo" [attr.aria-label]="ariaLabelSeccionMotivo()">
            <h3 class="dialog-detalles-ausencia__motivo-title">{{ etiquetaTituloMotivo() }}</h3>
            <p class="dialog-detalles-ausencia__motivo-text">
                {{ datosIncidencia.motivo?.trim() ? datosIncidencia.motivo : "—" }}
            </p>
        </section>

        @if (stepModeracion == 0) {
            <section class="dialog-detalles-ausencia__docs" [attr.aria-label]="ariaLabelDocumentacionPrevia()">
                <h3 class="dialog-detalles-ausencia__docs-title">
                    <mat-icon class="dialog-detalles-ausencia__docs-title-icon">attach_file</mat-icon>
                    {{ tituloDocumentacionPrevia() }}
                </h3>

                @if (documentosAnteriores.length === 0) {
                    <p class="dialog-detalles-ausencia__docs-empty">
                        {{ mensajeSinDocumentosPorTipo() }}
                    </p>
                } @else {
                    <div
                        class="dialog-detalles-ausencia__docs-grid"
                        fxLayout="row wrap"
                        fxLayoutAlign="start stretch"
                        fxLayoutGap="1rem"
                    >
                        @for (doc of documentosAnteriores; track doc.id) {
                            <div
                                class="ddoc-card"
                                [class.ddoc-card--required]="esDocObligatorio(doc)"
                                [class.ddoc-card--optional]="!esDocObligatorio(doc)"
                                [class.ddoc-card--attached]="tieneAdjunto(doc)"
                                fxFlex="1 1 260px"
                                fxLayout="column"
                                fxLayoutGap="0.4rem"
                            >
                                <div class="ddoc-card__watermark" aria-hidden="true">
                                    <mat-icon class="ddoc-card__watermark-icon">attach_file</mat-icon>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0.5rem">
                                    @if (esDocObligatorio(doc)) {
                                        <span
                                            class="ddoc-badge ddoc-badge--required"
                                            [class.ddoc-badge--adjuntado]="tieneAdjunto(doc)"
                                            >Obligatorio</span
                                        >
                                    } @else {
                                        <span
                                            class="ddoc-badge ddoc-badge--optional"
                                            [class.ddoc-badge--adjuntado]="tieneAdjunto(doc)"
                                            >Opcional</span
                                        >
                                    }
                                    @if (doc.aditionalInfo) {
                                        <mat-icon
                                            class="ddoc-card__info-icon"
                                            [matTooltip]="doc.aditionalInfo"
                                            matTooltipClass="ddoc-mat-tooltip"
                                            matTooltipShowDelay="200"
                                            tabindex="0"
                                            role="img"
                                            aria-label="Información adicional"
                                            >info_outline</mat-icon
                                        >
                                    }
                                </div>
                                <div class="ddoc-card__name-row">
                                    <span class="ddoc-card__title">{{ doc.name || "Documento" }}</span>
                                </div>
                                <div
                                    class="ddoc-card__footer"
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                    fxLayoutGap="0.5rem"
                                >
                                    @if (tieneAdjunto(doc)) {
                                        <button
                                            type="button"
                                            class="ddoc-card__file-link"
                                            (click)="onAbrirDocumentoTipologia(doc)"
                                        >
                                            <mat-icon class="ddoc-card__file-icon">description</mat-icon>
                                            <span
                                                class="ddoc-card__filename"
                                                [matTooltip]="nombreArchivoMostrado(doc)"
                                                >{{ nombreArchivoMostrado(doc) }}</span
                                            >
                                        </button>
                                    } @else {
                                        <div class="ddoc-card__sin-adjunto" aria-disabled="true">
                                            <mat-icon class="ddoc-card__sin-adjunto-icon">hourglass_empty</mat-icon>
                                            <span>Sin adjuntar</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </section>

            @if (documentosPosteriores.length !== 0) {
                <section class="dialog-detalles-ausencia__docs" [attr.aria-label]="ariaLabelDocumentacionPosterior()">
                    <h3 class="dialog-detalles-ausencia__docs-title">
                        <mat-icon class="dialog-detalles-ausencia__docs-title-icon">folder_special</mat-icon>
                        {{ tituloDocumentacionPosterior() }}
                    </h3>
                    <p class="dialog-detalles-ausencia__docs-intro">Tamaño máximo por archivo: 5 MB.</p>

                    <div
                        class="dialog-detalles-ausencia__posteriores-wrap"
                        [class.dialog-detalles-ausencia__posteriores-wrap--revisar]="
                            mostrarFlujoRevisarDocumentacionPosterior()
                        "
                    >
                        @if (documentosPosteriores.length === 0) {
                            <p class="dialog-detalles-ausencia__docs-empty">
                                {{ mensajeSinDocumentosPosterioresPorTipo() }}
                            </p>
                        } @else {
                            <div
                                class="dialog-detalles-ausencia__docs-grid"
                                fxLayout="row wrap"
                                fxLayoutAlign="start stretch"
                                fxLayoutGap="1rem"
                            >
                                @for (doc of documentosPosteriores; track trackIdDocPosterior($index, doc)) {
                                    <div
                                        class="ddoc-card"
                                        [class.ddoc-card--required]="esDocObligatorio(doc)"
                                        [class.ddoc-card--optional]="!esDocObligatorio(doc)"
                                        [class.ddoc-card--attached]="tieneAdjunto(doc)"
                                        fxFlex="1 1 260px"
                                        fxLayout="column"
                                        fxLayoutGap="0.4rem"
                                    >
                                        <input
                                            type="file"
                                            class="ddoc-card__native-file"
                                            [id]="idInputArchivoPosterior(doc.id)"
                                            (change)="onArchivoPosteriorSeleccionado(doc, $event)"
                                            tabindex="-1"
                                            aria-hidden="true"
                                        />
                                        <div class="ddoc-card__watermark" aria-hidden="true">
                                            <mat-icon class="ddoc-card__watermark-icon">attach_file</mat-icon>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0.5rem">
                                            @if (esDocObligatorio(doc)) {
                                                <span
                                                    class="ddoc-badge ddoc-badge--required"
                                                    [class.ddoc-badge--adjuntado]="tieneAdjunto(doc)"
                                                    >Obligatorio</span
                                                >
                                            } @else {
                                                <span
                                                    class="ddoc-badge ddoc-badge--optional"
                                                    [class.ddoc-badge--adjuntado]="tieneAdjunto(doc)"
                                                    >Opcional</span
                                                >
                                            }
                                            @if (doc.aditionalInfo) {
                                                <mat-icon
                                                    class="ddoc-card__info-icon"
                                                    [matTooltip]="doc.aditionalInfo"
                                                    matTooltipClass="ddoc-mat-tooltip"
                                                    matTooltipShowDelay="200"
                                                    tabindex="0"
                                                    role="img"
                                                    aria-label="Información adicional"
                                                    >info_outline</mat-icon
                                                >
                                            }
                                        </div>
                                        <div class="ddoc-card__name-row">
                                            <span class="ddoc-card__title">{{ doc.name || "Documento" }}</span>
                                        </div>
                                        <div
                                            class="ddoc-card__footer"
                                            fxLayout="column"
                                            fxLayoutAlign="center center"
                                            fxLayoutGap="0.5rem"
                                        >
                                            @if (tieneAdjunto(doc)) {
                                                <button
                                                    type="button"
                                                    class="ddoc-card__file-link"
                                                    (click)="onAbrirDocumentoTipologia(doc)"
                                                >
                                                    <mat-icon class="ddoc-card__file-icon">description</mat-icon>
                                                    <span
                                                        class="ddoc-card__filename"
                                                        [matTooltip]="nombreArchivoMostrado(doc)"
                                                        >{{ nombreArchivoMostrado(doc) }}</span
                                                    >
                                                </button>
                                                @if (puedeGestionarDocumentacionPosterior()) {
                                                    <button
                                                        type="button"
                                                        mat-stroked-button
                                                        color="primary"
                                                        class="ddoc-card__btn-posterior"
                                                        (click)="abrirSelectorArchivoPosterior(doc)"
                                                    >
                                                        <mat-icon>edit</mat-icon>
                                                        Cambiar archivo
                                                    </button>
                                                }
                                            } @else {
                                                @if (puedeGestionarDocumentacionPosterior()) {
                                                    <button
                                                        type="button"
                                                        mat-stroked-button
                                                        color="primary"
                                                        class="ddoc-card__btn-posterior"
                                                        (click)="abrirSelectorArchivoPosterior(doc)"
                                                    >
                                                        <mat-icon>upload_file</mat-icon>
                                                        Adjuntar archivo
                                                    </button>
                                                } @else {
                                                    <div class="ddoc-card__sin-adjunto" aria-disabled="true">
                                                        <mat-icon class="ddoc-card__sin-adjunto-icon"
                                                            >hourglass_empty</mat-icon
                                                        >
                                                        <span>Sin adjuntar</span>
                                                    </div>
                                                }
                                            }
                                            @if (nombreArchivoPosteriorPendiente(doc)) {
                                                <span class="ddoc-card__pendiente-local"
                                                    >Archivo elegido: {{ nombreArchivoPosteriorPendiente(doc) }}</span
                                                >
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        @if (mostrarFlujoRevisarDocumentacionPosterior()) {
                            @if (pasoValidacionDocsPosterior === 0) {
                                <div
                                    class="dialog-detalles-ausencia__validar-docs-acciones"
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                >
                                    <button
                                        type="button"
                                        mat-raised-button
                                        color="primary"
                                        class="dialog-detalles-ausencia__btn-validar-docs"
                                        (click)="iniciarConfirmacionValidarDocumentosPosterior()"
                                    >
                                        {{ textoBotonValidarDocumentacion() }}
                                    </button>
                                </div>
                            }
                            @if (pasoValidacionDocsPosterior === 1) {
                                <p class="dialog-detalles-ausencia__validar-docs-msg">
                                    {{ mensajeConfirmarValidacionDocumentacion() }}
                                </p>
                                <div
                                    class="dialog-detalles-ausencia__validar-docs-acciones"
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                    fxLayoutGap="12px"
                                >
                                    <button
                                        type="button"
                                        mat-button
                                        (click)="cancelarConfirmacionValidarDocumentosPosterior()"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        mat-raised-button
                                        color="primary"
                                        (click)="confirmarValidacionDocumentosIncidencia()"
                                    >
                                        Confirmar
                                    </button>
                                </div>
                            }
                        }
                    </div>
                </section>
            }

            @if (
                documentosAdicionales.length > 0 ||
                (datosIncidencia?.archivo && datosIncidencia?.archivo !== "" && datosIncidencia?.archivo !== "/")
            ) {
                <section
                    class="dialog-detalles-ausencia__docs dialog-detalles-ausencia__docs--adicional"
                    aria-label="Documentación adicional"
                >
                    <h3 class="dialog-detalles-ausencia__docs-title">
                        <mat-icon class="dialog-detalles-ausencia__docs-title-icon">folder_special</mat-icon>
                        Documentación adicional aportada
                    </h3>

                    <div
                        class="dialog-detalles-ausencia__docs-grid dialog-detalles-ausencia__docs-grid--adicional"
                        fxLayout="row wrap"
                        fxLayoutAlign="start start"
                        fxLayoutGap="1rem"
                    >
                        @if (
                            datosIncidencia?.archivo &&
                            datosIncidencia?.archivo !== "" &&
                            datosIncidencia?.archivo !== "/"
                        ) {
                            <div
                                class="ddoc-card ddoc-card--extra"
                                fxFlex="1 1 260px"
                                fxLayout="column"
                                fxLayoutGap="0.5rem"
                                (click)="showAdjunto(datosIncidencia?.id, datosIncidencia?.archivo)"
                            >
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                                    <span class="ddoc-badge ddoc-badge--extra">Adicional</span>
                                </div>
                                <div class="ddoc-card__name-row">
                                    <span class="ddoc-card__title">Archivo adjunto</span>
                                </div>

                                <div class="ddoc-card__meta">-</div>

                                <div
                                    class="ddoc-card__footer ddoc-card__footer--actions"
                                    fxLayout="row"
                                    fxLayoutAlign="stretch"
                                >
                                    <span class="ddoc-card__extra-hint">Click para ver el documento</span>
                                </div>
                            </div>
                        }
                        @for (doc of documentosAdicionales; track doc.hash) {
                            <div
                                class="ddoc-card ddoc-card--extra"
                                fxFlex="1 1 260px"
                                fxLayout="column"
                                fxLayoutGap="0.5rem"
                                (click)="onAbrirDocumentoTipologia(doc)"
                            >
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                                    <span class="ddoc-badge ddoc-badge--extra">Adicional</span>
                                </div>
                                <div class="ddoc-card__name-row">
                                    <span class="ddoc-card__title">{{ nombreArchivoMostrado(doc) }}</span>
                                </div>
                                @if (fechaDocAdicional(doc)) {
                                    <div class="ddoc-card__meta">{{ fechaDocAdicional(doc) }}</div>
                                }
                                <div
                                    class="ddoc-card__footer ddoc-card__footer--actions"
                                    fxLayout="row"
                                    fxLayoutAlign="stretch"
                                >
                                    @if (tieneAdjunto(doc)) {
                                        <span class="ddoc-card__extra-hint">Click para ver el documento</span>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </section>
            }

            @if (datosIncidencia.estado === 2) {
                <section class="dialog-detalles-ausencia__cancelacion" aria-label="Cancelación">
                    <h3 class="dialog-detalles-ausencia__cancelacion-title">Cancelación</h3>
                    <p class="dialog-detalles-ausencia__cancelacion-fecha">
                        <span class="dialog-detalles-ausencia__cancelacion-fecha-label">Moderada el</span>
                        {{ formatDateTime(datosIncidencia.dateModeracion) }}
                    </p>
                    <p class="dialog-detalles-ausencia__cancelacion-motivo">
                        {{ datosIncidencia.motivo_cancelacion?.trim() ? datosIncidencia.motivo_cancelacion : "—" }}
                    </p>
                </section>
            }
        }
    }

    @if (mostrarPanelModeracion() && stepModeracion != 0) {
        <section class="dialog-detalles-ausencia__moderacion-pendiente" [attr.aria-label]="ariaLabelPanelModeracion()">
            @if (stepModeracion === 1) {
                <p class="dialog-detalles-ausencia__moderacion-pendiente-msg">
                    {{ mensajeModeracionAceptar() }}
                </p>
            }
            @if (stepModeracion === 2) {
                <p class="dialog-detalles-ausencia__moderacion-pendiente-msg">
                    {{ mensajeModeracionDenegar() }}
                </p>
                <mat-form-field appearance="outline" class="dialog-detalles-ausencia__moderacion-field">
                    <mat-label>Motivo de cancelación</mat-label>
                    <textarea
                        matInput
                        [(ngModel)]="motivoRechazoModeracion"
                        rows="3"
                        maxlength="200"
                        placeholder="Motivo de cancelación..."
                    ></textarea>
                    <mat-hint align="end">{{ (motivoRechazoModeracion || "").length }}/200</mat-hint>
                </mat-form-field>
            }
            @if (stepModeracion === 3) {
                <p class="dialog-detalles-ausencia__moderacion-pendiente-msg">
                    {{ mensajeModeracionVolverPendiente() }}
                </p>
            }
        </section>
    }
</mat-dialog-content>
<mat-dialog-actions
    align="end"
    class="dialog-detalles-ausencia__actions"
    fxLayout="row wrap"
    fxLayoutAlign="end center"
    fxLayoutGap="12px"
>
    @if (mostrarAccionesModeracionRRHH()) {
        @if (stepModeracion === 0) {
            <button
                *ngIf="datosIncidencia?.estado != 0"
                type="button"
                mat-stroked-button
                color="primary"
                [disabled]="moderacionLoading"
                (click)="iniciarPasoPendiente()"
            >
                Pasar a pendiente
            </button>
            <button
                *ngIf="datosIncidencia?.estado != 1"
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--aceptar"
                [disabled]="moderacionLoading"
                (click)="iniciarPasoAceptar()"
            >
                Aceptar
            </button>
            <button
                *ngIf="datosIncidencia?.estado != 2"
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--rechazar"
                [disabled]="moderacionLoading"
                (click)="iniciarPasoRechazar()"
            >
                Denegar
            </button>
        }
        @if (stepModeracion === 1) {
            <button type="button" mat-button [disabled]="moderacionLoading" (click)="cancelarPasosModeracion()">
                Cancelar
            </button>
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--aceptar"
                [disabled]="moderacionLoading"
                (click)="ejecutarModeracion(1)"
            >
                Confirmar
            </button>
        }
        @if (stepModeracion === 2) {
            <button type="button" mat-button [disabled]="moderacionLoading" (click)="cancelarPasosModeracion()">
                Cancelar
            </button>
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--rechazar"
                [disabled]="moderacionLoading || !motivoRechazoModeracionValido()"
                (click)="ejecutarModeracion(2)"
            >
                Confirmar denegación
            </button>
        }
        @if (stepModeracion === 3) {
            <button type="button" mat-button [disabled]="moderacionLoading" (click)="cancelarPasosModeracion()">
                Cancelar
            </button>
            <button
                type="button"
                mat-stroked-button
                color="primary"
                [disabled]="moderacionLoading"
                (click)="ejecutarModeracion(0)"
            >
                Confirmar
            </button>
        }
    } @else if (mostrarAccionesModeracionManager()) {
        @if (stepModeracion === 0) {
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--aceptar"
                [disabled]="moderacionLoading"
                (click)="iniciarPasoAceptar()"
            >
                Aceptar
            </button>
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--rechazar"
                [disabled]="moderacionLoading"
                (click)="iniciarPasoRechazar()"
            >
                Rechazar
            </button>
        }
        @if (stepModeracion === 1) {
            <button type="button" mat-button [disabled]="moderacionLoading" (click)="cancelarPasosModeracion()">
                Cancelar
            </button>
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--aceptar"
                [disabled]="moderacionLoading"
                (click)="ejecutarModeracion(1)"
            >
                Confirmar
            </button>
        }
        @if (stepModeracion === 2) {
            <button type="button" mat-button [disabled]="moderacionLoading" (click)="cancelarPasosModeracion()">
                Cancelar
            </button>
            <button
                type="button"
                mat-raised-button
                class="dialog-detalles-ausencia__btn-moderar dialog-detalles-ausencia__btn-moderar--rechazar"
                [disabled]="moderacionLoading || !motivoRechazoModeracionValido()"
                (click)="ejecutarModeracion(2)"
            >
                Confirmar rechazo
            </button>
        }
    }
    <button mat-button type="button" (click)="cerrar()">Cerrar</button>
</mat-dialog-actions>
